
import React from 'react';
import Page from './layout/Page';
import Card from "./layout/Card";
import GasForm from './layout/GasForm';
import { setContactPriority } from '../api';
import { useLocation } from 'react-router-dom';

export default function ContattoPriorita() {

    const location = useLocation();
    const { id, contatto_title, numero } = location.state || {};

    return (            
        <GasForm 
            title={`Imposta priorità`}
            getAction="/contatto/id/{id}"
            showOnlyFields={['priorita', 'noteprerisposta', 'id']}
            saveAction="/prioritachiamata"
            saveBtnText="Imposta priorità"
            saveBtnPosition="end"
            showConfirmation={false}
            preComponent={<Card title={contatto_title} content={numero} variant="call-base-info" />}
        />
    );
}